/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Shopping_DoneInputs */

const en_plan_shopping_done = /** @type {(inputs: Plan_Shopping_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got everything`)
};

const de_plan_shopping_done = /** @type {(inputs: Plan_Shopping_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles da`)
};

/**
* | output |
* | --- |
* | "Got everything" |
*
* @param {Plan_Shopping_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_shopping_done = /** @type {((inputs?: Plan_Shopping_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Shopping_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_shopping_done(inputs)
	return en_plan_shopping_done(inputs)
});